export default function authHeader() {
  return { "x-access-token": localStorage.getItem("token") };
}
